/*
 * @Author: chenliang
 * @Date: 2021-02-03 16:02:26
 * @LastEditors: chenliang
 * @LastEditTime: 2021-02-03 16:28:46
 * @Description: 范围输入框
 */
import React, { Component } from 'react';
import { Input } from 'antd';
const InputGroup = Input.Group;

export default class RangeInput extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value1:'',
            value2:'',
        }
    }
    
    changeValue1 = (e) => {
        const { value,onChange } = this.props;
        onChange(Object.assign({},value,{value1:e.target.value}))
    }

    changeValue2 = (e) => {
        const { value,onChange } = this.props;
        onChange(Object.assign({},value,{value2:e.target.value}))
    }
  
    render() {

        const { value, placeholder1,placeholder2 } = this.props;

        let value1 = "";
        if (value !== undefined && value.value1 !== undefined){
            value1 = value.value1;
        }

        let value2 = "";
        if (value !== undefined && value.value2 !== undefined){
            value2 = value.value2;
        }

        return (
        <div className="range_input">
            <InputGroup compact>
            <Input value = {value1}  onChange={(e) => {this.changeValue1(e)}} style={{ width: 100, textAlign: 'center' }} placeholder={placeholder1} />
            <Input
                style={{
                width: 30,
                borderLeft: 0,
                pointerEvents: 'none',
                backgroundColor: '#fff',
                }}
                placeholder="~"
                disabled
            />
            <Input  value = {value2}  onChange={(e) => {this.changeValue2(e)}} style={{ width: 100, textAlign: 'center', borderLeft: 0 }} placeholder={placeholder2} />
            </InputGroup>
        </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormCustomItem/RangeInput.js